import React from 'react';

const Error = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundImage: 'url(img/vizor-background.png)',
      height: '100%',
      color: 'rgb(255, 255, 255)',
      fontSize: 20,
    }}
  >
    <a href=".">
      <img
        alt=""
        src="img/vizor-logo-103x122.png"
        height="122"
        width="103"
        style={{ marginRight: 5 }}
      />
    </a>
    <div>Whoops... Unexpected error</div>
    <div>Click the logo to reload the page</div>
  </div>
);

export default Error;
